import { gql } from '@apollo/client';
import atlBidEventFragment from './atlBidEventFragment';

const REMOVE_ATL_BID_ON_EVENT = gql`
  mutation RemoveATLBindingOnEvent($eventId: Int!) {
    removeATLBidOnEvent(eventId: $eventId) {
      ...AtlBidEventFields
    }
  }
  ${atlBidEventFragment}
`;

export default REMOVE_ATL_BID_ON_EVENT;
